// from https://github.com/google/material-design-lite/blob/d05739693d92a3e981cec6a02cf064d4064f1328/src/_variables.scss#L486
export function defaultTransition(property = 'all', duration = 300, delay = 0) {
    return {
        transitionProperty: property,
        transitionDuration: `${duration}ms`,
        transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
        transitionDelay: `${delay}ms`,
    };
}
